import { FieldArray, FormikProps, FormikProvider } from "formik";
import { VerticalSpacing } from "../VerticalSpacing";
import { AddSourceFormik } from "../V3ModalUniversalAddContent/AddSource/AddSource.utils";
import { SignupAddContentAddAliasCTA, SignupAddContentAddAliasCTAText } from "./AddAliases.styles";
import { V3BodyGrey35 } from "../ReusableStyledComponents/V3BodyGrey35";
import { V3BlueRoundPlus } from "../ReusableStyledComponents/V3BlueRoundPlus";
import { V3TextInput } from "../TextInput/V3TextInput";

interface AddAliasesProps {
    formik: FormikProps<AddSourceFormik>,
    userName: string,
    disabled?: boolean,
}

export const AddAliases = ({ formik, userName, disabled = false }: AddAliasesProps) => {
    return <VerticalSpacing bottom={24}>
        <FormikProvider value={formik}>
            <FieldArray
                name="aliases"
                render={(arrayHelpers) => {
                    const { values, errors, touched, handleBlur } = arrayHelpers.form as FormikProps<AddSourceFormik>;

                    return <>
                        <div>
                            <V3BodyGrey35>We'll search for articles with this byline: <strong>{`${userName}`}</strong></V3BodyGrey35>
                        </div>
                        {
                            values.aliases.map((alias, index) => {
                                let error = undefined;

                                if (typeof errors.aliases === "string" && index === 0) {
                                    error = errors.aliases;
                                } else if (errors.hasOwnProperty("aliases")
                                    && Array.isArray(errors.aliases)
                                    && errors.aliases[index]
                                    && touched.hasOwnProperty("aliases")
                                    && Array.isArray(touched.aliases)
                                    && touched.aliases[index]) {
                                    error = errors.aliases[index];
                                }

                                return (
                                    <VerticalSpacing top={12} key={`aliases.${index}`}>
                                        <V3TextInput
                                            name={`aliases.${index}`}
                                            value={alias}
                                            placeholder={`e.g. Jim Doe`}
                                            onChange={(e) => {
                                                arrayHelpers.replace(index, e.target.value);
                                            }}
                                            onBlur={handleBlur}
                                            label={index === 0 ? "Alias" : undefined}
                                            //@ts-ignore
                                            error={error}
                                            autoCapitalize="none"
                                            disabled={disabled}
                                        />
                                    </VerticalSpacing>
                                );
                            })
                        }
                        <VerticalSpacing top={18}>
                            <SignupAddContentAddAliasCTA
                                as="div"
                                onClick={() => {
                                    arrayHelpers.push("");
                                }}
                            >
                                <div><V3BlueRoundPlus /></div>
                                <SignupAddContentAddAliasCTAText>
                                    <strong>Add an alias</strong>
                                </SignupAddContentAddAliasCTAText>
                            </SignupAddContentAddAliasCTA>
                        </VerticalSpacing>
                    </>
                }}
            />
        </FormikProvider>
    </VerticalSpacing>
}